<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],    
 data() {
  return {
   title: "User Management",
   text: "User Management",
   text1: "Roles & Permissions",
   toast: useToast(),
   data: [],
   modules: [],
   searchText: '',
   columns: [
    {
     title: 'S.No',
     dataIndex: 'SNo',
     key: 'SNo',
    },
    {
     title: 'Role Name',
     dataIndex: 'RoleName',
     key: 'RoleName',
    },
    {
     title: 'Actions',
     key: 'action',
    },
   ],
    rowSelection: null,
  };
},

 computed: {
  filteredData() {
    if (!this.searchText) return this.data;
    const search = this.searchText.toLowerCase();
    return this.data.filter(item => item.name?.toLowerCase().includes(search));
  },
 },

 mounted() {
  this.getModules();  
  this.rolesPermissions();
 }, 
 methods: {

 async getModules(){
  this.setLoading(true);
  try{
   const response = await axios.get('/modules');
   this.modules = response.data.data;
  }catch(error){
   this.toast.error(error.message);
  }finally{
   this.setLoading(false);
  }
 },

 async rolesPermissions(){
  this.setLoading(true);
  try{
   const response = await axios.get('/roles');
   this.data = response.data.data;
  }catch(error){
   this.toast.error(error.message);
  }finally{
   this.setLoading(false);
  }
 }

},
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
<div class="mb-2">
<a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#role_permission_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.rolePermissionModal.add();"><i class="ti ti-circle-plus me-2"></i>Add Role</a>
</div>
<div class="head-icons ms-2">

</div>
</div>
</div>
<!-- /Breadcrumb -->

<div class="card">
<div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
<h5>Roles List</h5>
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
<!-- <div class="dropdown">
 <a href="javascript:void(0);"
    class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
    data-bs-toggle="dropdown"
    >
    Sort By : Last 7 Days
    </a>
    <ul class="dropdown-menu dropdown-menu-end p-3">
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Recently Added</a
        >
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Ascending</a
        >
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Desending</a
        >
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Last Month</a
        >
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1"
        >Last 7 Days</a
        >
    </li>
    </ul>
</div> -->
</div>
</div>
<div class="card-body p-0">
<div class="custom-datatable-filter table-responsive">

<a-table v-if="filteredData.length" class="table datatable thead-light" :columns="columns" :data-source="filteredData"
  :row-selection="rowSelection">
  <template #bodyCell="{ column, record, index }">
    <template v-if="column.key === 'SNo'"> {{ index + 1 }}. </template>   
    <template v-if="column.key === 'RoleName'">
      <h6 class="fs-14 fw-medium">
        <router-link to="#">{{ record.name }}</router-link>
      </h6>
    </template>
    <template v-if="column.key === 'action'">
      <div class="action-icon d-inline-flex">
       <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#role_permission_modal" class="me-2" @click="$refs.rolePermissionModal.editRole(record)"><i class="ti ti-edit"></i></a>
      <a href="javascript:void(0);" class="text-danger" data-bs-toggle="modal" data-bs-target="#delete_modal" @click="$refs.rolePermissionModal.editRole(record)"><i class="ti ti-trash"></i></a>
      </div>
    </template>
  </template>
</a-table>

<div v-else class="p-3 text-center text-muted">
  No records found.
</div>

</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<role-permission-modal :modules="modules" ref="rolePermissionModal" @updated="rolesPermissions"></role-permission-modal>
</template>
